<div class="sidebar-back"></div>

<div class="left-sidebar">
    <div class="left-sidebar-back"><img src="/assets/img/Home-Slide-Peak-Top.jpg" /></div>

    <div class="list-menu">
        <ul>
            <li class="mb-3">
                <a href="javascript:;" tooltip="{{userName}}" placement="right"><img [src]="currentUserPhoto | userPhoto" /></a>
            </li>
            <li><a href="javascript:;" (click)="showChangePasswordModal()" tooltip="Şifre Değiştir" placement="right"><i
                        class="uil uil-keyhole-circle"></i></a></li>
            <li><a href="javascript:;" id="logout" (click)="logout()" tooltip="Çıkış Yap" placement="right"><i
                        class="uil uil-sign-out-alt"></i></a></li>
        </ul>
        <ul>
            <li><a id="menu-toggle" href="javascript:;" tooltip="Menü" placement="right"><i
                        class="uil uil-bars"></i></a></li>
        </ul>
    </div>
</div>
<div id="sidebar-wrapper">
    <div class="sidebar-heading">
        <div class="logo-background mx-auto">
            <div class="row">
                <div class="col-md-12 align-self-center">
                    <a [routerLink]="getRoleUrl()">
                        <img class="img-fluid" src="/assets/img/peak-gelisim-logo.png">
                    </a>
                </div>
            </div>

        </div>
    </div>
    <div class="list-group list-group-flush">

        <div class="wrapper">
            <nav id="sidebar">
                <ul class="list-unstyled  components">
                    <ng-template [ngIf]="role == 'ADMIN'">
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim"><i class="uil uil-estate"></i> Ana Sayfa</a>
                        </li>

                        <li>
                            <a class="sidenav-link" routerLink="/yonetim/customers"><i
                                    class="uil uil-user menu-icon"></i>Müşteriler</a>
                        </li>

                        <!-- <li>
                            <a class="sidenav-link"><i
                                    class=" uil uil-file-exclamation-alt menu-icon"></i>Teklifler</a>
                        </li> -->

                        <li>
                            <a class="sidenav-link" routerLink="/yonetim/assessments"><i
                                    class=" uil uil-presentation-line menu-icon"></i>Assesment</a>
                        </li>

                        <li>
                            <a class="sidenav-link" routerLink="/yonetim/trainings"><i
                                    class="uil uil-meeting-board menu-icon"></i>Eğitimler</a>
                        </li>

                        <!-- <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/classes"><i
                                    class="uil uil-sitemap"></i>Takip</a>
                        </li> -->
                        <!-- <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/classes"><i
                                    class="uil uil-file-check"></i>Assesment</a>
                        </li> -->
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/instructors"><i
                                    class="uil uil-user-md"></i>Eğitmenler</a>
                        </li>
                        <!-- <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/onlinebirebir"><i class="uil uil-users-alt"></i>
                                Koçluklar</a>
                        </li> -->
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="uil uil-calculator"></i>Muhasebe</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/companies"><i
                                            class="uil uil-building menu-icon"></i>Cariler</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/transaction"><i
                                            class=" uil uil-lira-sign menu-icon"></i>Gelir & Gider</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/safebox"><i
                                            class=" uil uil-university menu-icon"></i>Kasa & Banka</a>
                                </li>
                                <!-- <li>
                                    <a class="sidenav-link"><i
                                            class=" uil uil-chart-line menu-icon"></i>Finans Raporları</a>
                                </li> -->
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/financecategory"><i
                                            class="uil uil-invoice"></i>Ücret Kalemleri</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/category"><i
                                            class="uil uil-list-ui-alt"></i>Kategoriler</a>
                                </li>
                            </ul>
                        </li>

                        <!-- <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/rapor"><i class="uil uil-chart-line"></i>
                                Raporlar</a>
                        </li> -->

                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/announcements"><i class="uil uil-megaphone"></i>
                                Duyurular</a>
                        </li>
                        <!-- <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="uil uil-book-reader"></i>Şablonlar</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/survey-templates"><i
                                            class=" il uil-file-info-alt menu-icon"></i>Test & Vaka Şablonları</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/document-templates"><i
                                            class=" il uil-file-info-alt menu-icon"></i>Dökümanlar</a>
                                </li>
                                
                            </ul>

                        </li> -->
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-book-reader  menu-icon"></i>Kütüphane</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/document-templates"><i
                                            class=" il uil-file-info-alt menu-icon"></i>Dokümanlar</a>
                                </li>
                                <li class="dropdown">
                                    <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-subject  menu-icon"></i>Anketler</a>
                                    <ul class="collapse list-unstyled  list-unstyled-sub ">
                                        <li>
                                            <a class="sidenav-link" routerLink="/yonetim/survey-contact-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>İletişim Anketleri</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/yonetim/survey-sales-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Satış Anketleri</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/yonetim/survey-manager-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Yönetim Anketleri</a>
                                        </li>

                                    </ul>
                                </li>
                                <li class="dropdown">
                                    <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-subject  menu-icon"></i>Vakalar</a>
                                    <ul class="collapse list-unstyled  list-unstyled-sub ">
                                        <li>
                                            <a class="sidenav-link" routerLink="/yonetim/vaka-customer-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Müşteri Vakaları</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/yonetim/vaka-sales-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Satış Vakaları</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/yonetim/vaka-manager-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Yönetim Vakaları</a>
                                        </li>

                                    </ul>
                                </li>
                                
                                
                            </ul>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-setting  menu-icon"></i>Ayarlar</a>
                            <ul class="collapse list-unstyled">
                                <li class="dropdown">
                                    <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-subject  menu-icon"></i>Tanımlar</a>
                                    <ul class="collapse list-unstyled  list-unstyled-sub ">
                                        <li>
                                            <a class="sidenav-link" routerLink="/yonetim/activity-category"><i
                                                    class="uil uil-notes menu-icon"></i>Aktivite Türleri</a>
                                        </li>

                                    </ul>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/users"><i
                                            class="uil uil-users-alt menu-icon"></i>Kullanıcılar</a>
                                </li>
                                <!-- <li>
                                    <a class="sidenav-link" routerLink="/yonetim/handover"><i class="uil uil-user-arrows menu-icon"></i>Ders
                                        Devri</a>
                                </li> -->
                            </ul>
                        </li>
                    </ng-template>

                    <ng-template [ngIf]="role == 'INSTRUCTOR'">
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/egitmen"><i class="uil uil-estate"></i> Ana Sayfa</a>
                        </li>
                        <li>
                            <a class="sidenav-link" routerLink="/egitmen/customers"><i
                                    class="uil uil-user menu-icon"></i>Müşteriler</a>
                        </li>
                        <li>
                            <a class="sidenav-link" routerLink="/egitmen/assessments"><i
                                    class=" uil uil-presentation-line menu-icon"></i>Assesmentlarım</a>
                        </li>
                        <li>
                            <a class="sidenav-link" routerLink="/egitmen/trainings"><i
                                    class=" uil uil-meeting-board menu-icon"></i>Eğitimlerim</a>
                        </li>
                        <li>
                            <a class="sidenav-link" routerLink="/egitmen/general-calendar"><i
                                    class="uil uil-calendar-alt menu-icon"></i>Takvim</a>
                        </li>
                        <!-- <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="uil uil-book-reader"></i>Şablonlar</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/egitmen/survey-templates"><i
                                            class=" il uil-file-info-alt menu-icon"></i>Test & Vaka Şablonları</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/egitmen/document-templates"><i
                                            class=" il uil-file-info-alt menu-icon"></i>Döküman Şablonları</a>
                                </li>
                                
                            </ul>

                        </li> -->
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-book-reader  menu-icon"></i>Kütüphane</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/egitmen/document-templates"><i
                                            class=" il uil-file-info-alt menu-icon"></i>Dokümanlar</a>
                                </li>
                                <li class="dropdown">
                                    <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-subject  menu-icon"></i>Anketler</a>
                                    <ul class="collapse list-unstyled  list-unstyled-sub ">
                                        <li>
                                            <a class="sidenav-link" routerLink="/egitmen/survey-contact-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>İletişim Anketleri</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/egitmen/survey-sales-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Satış Anketleri</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/egitmen/survey-manager-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Yönetim Anketleri</a>
                                        </li>

                                    </ul>
                                </li>
                                <li class="dropdown">
                                    <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-subject  menu-icon"></i>Vakalar</a>
                                    <ul class="collapse list-unstyled  list-unstyled-sub ">
                                        <li>
                                            <a class="sidenav-link" routerLink="/egitmen/vaka-customer-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Müşteri Vakaları</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/egitmen/vaka-sales-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Satış Vakaları</a>
                                        </li>
                                        <li>
                                            <a class="sidenav-link" routerLink="/egitmen/vaka-manager-templates"><i
                                                    class="uil uil-file-info-alt menu-icon"></i>Yönetim Vakaları</a>
                                        </li>

                                    </ul>
                                </li>
                                
                                
                            </ul>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-setting  menu-icon"></i>Ayarlar</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/egitmen/activity-category"><i
                                            class="uil uil-notes menu-icon"></i>Aktivite Türleri</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/egitmen/users"><i
                                            class="uil uil-users-alt menu-icon"></i>Kullanıcılar</a>
                                </li>
                            </ul>
                        </li>
                        <!-- <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/egitmen/siniflarim"> <i class="uil uil-book-alt menu-icon"></i>Sınıflar</a>
                        </li>
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/egitmen/sorularim"><i
                                    class="uil uil-comment-alt-dots"></i>
                                Soru
                                Çözüm</a>
                        </li>

                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/egitmen/onlinebirebir"><i class="uil uil-users-alt"></i>
                                Online Birebir</a>
                        </li> -->
                    </ng-template>

                    <ng-template [ngIf]="role == 'PERSONNEL'">
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class="uil uil-book-reader"></i>Öğrenci İşleri</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/students"><i class="uil uil-book-reader"></i>Kayıt</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/students"><i class="uil uil-graduation-cap"></i>Öğrenci
                                        Listesi</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/parents"><i
                                            class=" uil uil-users-alt menu-icon"></i>Veliler</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/students"><i
                                            class=" fas fa-lira-sign menu-icon"></i>Tahsilat</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/yonetim/students"><i class=" fas fa-list menu-icon"></i>Hizmet
                                        Kalemleri</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/classes"><i
                                    class="uil uil-sitemap"></i>Şubeler</a>
                        </li>
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/yonetim/courses"><i
                                    class="uil uil-user-md"></i>Kurslar</a>
                        </li>
                        <li>
                            <a href="javascript:;"><i class="fas fa-clipboard-list menu-icon"></i>Devamsızlık</a>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="fas fa-calendar-alt menu-icon"></i>Takvim</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Sınavlar</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Quizler</a>
                                </li>

                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Etütler</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Birebirlerim</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Randevular</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="javascript:;" data-target="#"><i
                                    class="far fa-clipboard menu-icon"></i>Raporlar</a>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="fas fa-file-signature menu-icon"></i>Sözleşmeler</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Öğrenci Sözleşmeleri</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Mesafeli Satış Sözleşmesi</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Personel Sözeşmeleri</a>
                                </li>
                            </ul>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="uil uil-subject  menu-icon"></i>Tanımlar</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Kullanıcılar</a>
                                </li>
                            </ul>
                        </li>
                    </ng-template>

                    <ng-template [ngIf]="role == 'PARENT'">
                        <li>
                            <a href="javascript:;"><i class="uil uil-estate"></i> Ana Sayfa</a>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i
                                    class="fas fa-clipboard-check menu-icon"></i>Değerlendirme</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Sınavlar</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Tarama Deneme</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Dersler</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Ödevler</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a href="javascript:;"><i class="fas fa-clipboard-list menu-icon"></i>Devamsızlık</a>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i
                                    class="uil uil-presentation-teacher  menu-icon"></i>Etütler</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Online Birebir</a>
                                </li>
                            </ul>
                        </li>
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"><i class="fas fa-calendar-alt menu-icon"></i>Takvim</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Sınavlar</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Quizler</a>
                                </li>

                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Etütler</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Birebirlerim</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" href="javascript:;" data-target="#">Randevular</a>
                                </li>
                            </ul>
                        </li>
                        <li>
                            <a class="sidenav-link" href="javascript:;"><i class="fas fa-file-signature menu-icon"></i>Sözleşmeler</a>
                        </li>
                        <li>
                            <a class="sidenav-link" href="javascript:;"><i class="fas fa-calendar-day menu-icon"></i>Randevular</a>
                        </li>
                    </ng-template>

                    <ng-template [ngIf]="role == 'STUDENT'">
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/ogrenci"><i class="uil uil-estate"></i> Ana Sayfa</a>
                        </li>
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/ogrenci/training"><i
                                    class="uil uil-presentation-line menu-icon"></i>Eğitimlerim</a>
                        </li>
                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/ogrenci/vakas"><i
                                    class="uil uil-comment-alt-dots"></i>
                               Vakalarım</a>
                        </li>

                        <li>

                            <a class="sidenav-link" href="javascript:;" routerLink="/ogrenci/tests"><i class=" uil uil-file-check-alt "></i>
                               Testlerim</a>
                        </li>

                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/ogrenci/document"><i class=" uil-clipboard-alt"></i>
                                Dokümanlarım</a>
                        </li>

                        <li>
                            <a class="sidenav-link" href="javascript:;" routerLink="/ogrenci/report"><i class="uil uil-file-medical-alt"></i>
                                Raporlarım</a>
                        </li>
                    </ng-template>

                    <ng-template [ngIf]="isPerasis && false">
                        <li class="dropdown">
                            <a href="javascript:;" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle">
                                <i class=" uil uil-briefcase-alt menu-icon"></i>Müşteri Yönetimi</a>
                            <ul class="collapse list-unstyled">
                                <li>
                                    <a class="sidenav-link" routerLink="/tenant/tenants"><i class="uil uil-file-edit-alt menu-icon"></i>Abone
                                        İşlemleri</a>
                                </li>
                                <li>
                                    <a class="sidenav-link" routerLink="/tenant/announcements"><i class="uil uil-megaphone menu-icon"></i>Duyurular</a>
                                </li>
                            </ul>
                        </li>
                    </ng-template>
                </ul>
            </nav>

        </div>
    </div>
</div>

<app-modal [(isVisible)]="isVisibleChangePasswordModal" sizeClass="">
    <app-change-password (onResult)="onChangePassword($event)" (onCancel)="hideModal()"></app-change-password>
</app-modal>